import { s } from './icon.style'
import React from 'react'
import type { IconProps } from '../iconProps'

export const NotificationIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2243_6)">
          <path
            d="M18 11V16L20 18V19H4V18L6 16V11C6 7.92 7.63 5.36 10.5 4.68V4C10.5 3.17 11.17 2.5 12 2.5C12.83 2.5 13.5 3.17 13.5 4V4.68C16.36 5.36 18 7.93 18 11Z"
            fill="black"
            fill-opacity="0.87"
          />
          <path
            d="M14 20C14 21.1 13.1 22 12 22C10.89 22 10 21.1 10 20H14Z"
            fill="black"
            fill-opacity="0.87"
          />
        </g>
        <defs>
          <clipPath id="clip0_2243_6">
            <rect fill="white" />
          </clipPath>
        </defs>
      </svg>
    )
  }
)
